/**
 * 媒体资源类型
 */
enum LearningResourceType {
  /**
   * 800Li视频
   */
  RESOURCE_800LI = 0,
  /**
   * 保利威视
   */
  RESOURCE_POLYV = 1,
  /**
   * 华为云视频
   */
  RESOURCE_HUA_WEI_VIDEO = 2,
  /**
   * 华为云音频
   */
  RESOURCE_HUA_WEI_AUDIO = 20,
  /**
   * PDF文档
   */
  RESOURCE_PDF_DOCUMENT = 900
}

export default LearningResourceType
